import { initFilterCollections } from '../components/filter-section-rendering';
import '../scss/collection.scss';
import { toggleDataActive } from '../utils/toggle-dataset';

toggleDataActive('.filter-open', '#filter', {
  overlay: false,
});

initFilterCollections();

window.addEventListener('scroll', () => {
  const activeFilter = document.querySelector(
    `.accordion-item__button[data-active="true"]`
  );
  if (activeFilter) {
    const filterBox = activeFilter.parentElement.querySelector(
      '.accordion-item__content'
    );
    const { top, height } = filterBox.getBoundingClientRect();

    if (top + height < 50) {
      activeFilter.setAttribute('data-active', 'false');
    }
  }
});
